// console.log('✅ quick-view.js loaded');
/* -- 产品列表快速浏览按钮 09/25 -- */

/* --图片滑块 & 模态框 -- */
function initSlider(container) {
  console.log('初始化图片滑块');

  const sliderEl = container.querySelector('.pqv-custom-table-slider');
  if (!sliderEl) return;

  // CSS 保证宽度自适应
  sliderEl.style.width = '100%';
  sliderEl.style.maxWidth = '100%';
  sliderEl.style.overflow = 'hidden';

  const mainSlides = sliderEl.querySelectorAll('.swiper-slide');

  function initMainSwiper() {
    const mainSwiper = new Swiper(sliderEl, {
      loop: mainSlides.length > 1, // 单 slide 不开启 loop
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: sliderEl.querySelector('.custom-table-slider-button-next'),
        prevEl: sliderEl.querySelector('.custom-table-slider-button-prev'),
      },
    });

    // 单 slide 隐藏导航
    if (mainSlides.length <= 1) {
      const nextBtn = sliderEl.querySelector('.custom-table-slider-button-next');
      const prevBtn = sliderEl.querySelector('.custom-table-slider-button-prev');
      if (nextBtn) nextBtn.style.display = 'none';
      if (prevBtn) prevBtn.style.display = 'none';
    }
  }

  // 延迟初始化：容器隐藏时等待显示
  if (sliderEl.offsetParent !== null) {
    initMainSwiper();
  } else {
    const observer = new MutationObserver(() => {
      if (sliderEl.offsetParent !== null) {
        initMainSwiper();
        observer.disconnect();
      }
    });
    observer.observe(sliderEl, { attributes: true, attributeFilter: ['style', 'class'] });
  }

  // 弹窗 modal
  const modal = document.getElementById('pqv-image-modal');
  if (!modal) return;
  const closeBtn = modal.querySelector('.custom-modal-close');
  let modalSwiper;

  container.querySelectorAll('.custom-table-slider-image').forEach((img, index) => {
    img.addEventListener('click', function () {
      const image_modal = document.querySelector('.custom-image-modal');
      if (!image_modal) return;
      document.body.appendChild(image_modal);

      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';

      setTimeout(() => {
        const modalSlides = modal.querySelectorAll('.custom-modal-slider .swiper-slide');

        if (!modalSwiper) {
          modalSwiper = new Swiper(modal.querySelector('.custom-modal-slider'), {
            loop: modalSlides.length > 1,
            slidesPerView: 1,
            navigation: {
              nextEl: modal.querySelector('.custom-modal-button-next'),
              prevEl: modal.querySelector('.custom-modal-button-prev'),
            },
            pagination: {
              el: modal.querySelector('.custom-modal-pagination'),
              clickable: true,
            },
          });

          // 单 slide 隐藏导航
          if (modalSlides.length <= 1) {
            const nextBtn = modal.querySelector('.custom-modal-button-next');
            const prevBtn = modal.querySelector('.custom-modal-button-prev');
            if (nextBtn) nextBtn.style.display = 'none';
            if (prevBtn) prevBtn.style.display = 'none';
          }
        } else {
          modalSwiper.update();
        }

        modalSwiper.slideToLoop(index);
      }, 50);
    });
  });

  // 关闭 modal
  function closeModal() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });
}

/* -- Tab 切换 -- */
function initTabs(container) {
  const tabs = container.querySelectorAll('.spec-tab');
  const panes = container.querySelectorAll('.spec-tab-pane');

  if (!tabs.length || !panes.length) return;

  tabs.forEach((tab) => {
    tab.addEventListener('click', function () {
    //   console.log('点击切换');

      tabs.forEach((t) => t.classList.remove('active'));
      panes.forEach((p) => {
        p.classList.remove('active');
        p.style.display = 'none';
      });

      this.classList.add('active');
      const tabId = 'pqv-spec-tab-' + this.getAttribute('data-tab');
      const activePane = container.querySelector('#' + tabId);
      if (activePane) {
        activePane.classList.add('active');
        activePane.style.display = 'block';
      }
    });
  });
}

/* -- Measurement 弹窗 -- */
function initMeasurement(container){
    const openBtn = container.querySelector('.hut-open-popup-btn');
    const closeBtn = document.querySelector('.hut-close-popup-btn');
    const overlay = document.querySelector('.hut-popup-overlay');
    const body = document.body;

    if (!openBtn || !closeBtn || !overlay) return;
    if (openBtn.dataset.measurementBound === 'true') return;

    openBtn.dataset.measurementBound = 'true';

    openBtn.addEventListener('click', () => {
      overlay.style.display = 'flex';
      body.style.overflow = 'hidden';
    });

    closeBtn.addEventListener('click', () => {
      overlay.style.display = 'none';
      body.style.overflow = ''; 
    });
}

function initServiceDrawer(container, triggerSelector, drawerId) {
  const openButtons = document.querySelectorAll(triggerSelector);
  const key = `ServiceGuarantee_${drawerId}`;

  openButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      window[key]?.open();// 调用全局暴露的方法
    });
  });
}

function initCertificationDrawer(container) {
  const openButtons = document.querySelectorAll('[data-open-certification]');
  openButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      window.ProductCertification?.open(btn.dataset.certType);// 调用全局暴露的方法
    });
  });
}

/* -- 初始化入口 -- */
function initQuickViewScripts(container) {
  console.log('⚡ initQuickViewScripts 执行了');
  initSlider(container);
  initTabs(container);
  initMeasurement(container);
  // Service Guarantee
  initServiceDrawer(container,'[data-open-service-guarantee]','sections--22474611032319__service_guarantee_drawer_zmXByx');
  // 30 Day Price Match
  initServiceDrawer(container,'[data-open-30-day-price-match]','sections--20177818321151__service_guarantee_drawer_HVU9E9');
  // Houlte & Taskrabbit
  initServiceDrawer(container,'[data-open-houlte-taskrabbit-popup]','sections--22474611032319__service_guarantee_drawer_PmeGKJ');
  // Materials Used in Our Furniture
  initServiceDrawer(container,'[data-materials-used-in-our-furniture]','sections--22474611032319__service_guarantee_drawer_FBTUCT');

  initCertificationDrawer(container);
}

/* -- 暴露到全局 -- */
window.initQuickViewScripts = initQuickViewScripts;
